import React from 'react';
import {
  BodyTextSkeleton,
  skeletonAnimation,
  SkeletonContainer
} from '~/App/shared/components/Skeletons';
import styled from 'styled-components';

const ImageSkeletonLoader = styled.div`
  width: 100%;
  padding-bottom: 100%;
  position: relative;
  margin-bottom: 1rem;
  ${skeletonAnimation}
`;

const DateSkeleton = styled(BodyTextSkeleton)`
  width: 60%;
  margin-top: 0.5rem;
`;

function ArticleCardSkeleton() {
  return (
    <SkeletonContainer data-testid="skeleton" as="li">
      <ImageSkeletonLoader aria-hidden="true" />
      <BodyTextSkeleton />
      <DateSkeleton />
    </SkeletonContainer>
  );
}

export default ArticleCardSkeleton;
